import Title from './component';

export default Title;
